var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broker-lead-kanban-view"},[_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('lead-kanban')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }